import {useEffect, useState} from 'react';

export default function useSessionStorage(key: string) {
    const [value, setValue] = useState(() => {
        try {
            const storedValue = window.sessionStorage.getItem(key);
            return storedValue ? JSON.parse(storedValue) : undefined;
        } catch (error) {
            console.error(error);
            return undefined;
        }
    });

    useEffect(() => {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(error);
        }
    }, [key, value]);

    return [value, setValue];
}
